module.exports = __webpack_public_path__ + "img/bodyMale.ef1abd9f.png";